export default __webpack_public_path__ + "static/pool-10545b0b3c7c6d59a0a570d266965fe5.webp";